export default "__VITE_ASSET__B1ePY$Bs__"